import { css } from '@emotion/css';
import { theme } from 'antd';
import { useMemo } from 'react';

export const useBefundDetailsContentStyles = () => {
  const { token } = theme.useToken();

  return useMemo(
    () => ({
      empty: css`
        flex-grow: 1;

        @media (max-width: ${token.screenLG}px) {
          display: none;
        }
      `,
    }),
    [token]
  );
};
